import Navbar from '../shared/Navbar'
import TittleBanner from '../shared/TittleBanner'
import DescBanner from '../shared/DescBanner'
import Footer from '../Footer/footer'
import architect from '../assets/images/services/architectLogo.png'
import qualityAssurance from '../assets/images/services/quality-assurance.png'
import timeline from '../assets/images/services/timeline.png'
import architectSupervise from '../assets/images/services/architect.png'
import MaterialTailwindCard from '../shared/Card'

export default function Supervising() {
  return (
    <div>
      <Navbar/>
      <TittleBanner img="bg-about-us-banner" tiitle="supervising"/>
      <DescBanner text="At Arcium Studio, our supervising service ensures that every stage of your project is executed with precision, quality, and efficiency. From groundbreaking to final touches, we oversee construction activities to make sure the design vision is realized exactly as planned.
      We coordinate with contractors, manage timelines, and monitor workmanship to prevent errors and delays. By staying actively involved throughout the process, we guarantee that materials, techniques, and finishes meet the highest standards.
      Our supervision approach is proactive, detail-oriented, and focused on delivering a flawless result—so you can have peace of mind knowing your project is in expert hands.
      Let us guide your project from blueprint to reality with professionalism and care." />
      <div className='mt-24 mb-16'>
      <h1 className="flex justify-center text-center items-center text-2xl md:text-3xl mt-4 mb-4 font-roboto font-bold">Services for supervising</h1>
      <div className='flex justify-center md:justify-between gap-5 p-5 flex-wrap align-middle items-center'>
        <MaterialTailwindCard imageStyle="p-5" button="hidden" tittle="Construction Oversight" desc="Ensure every phase of construction follows the design plan." img={architect}/>
        <MaterialTailwindCard imageStyle="p-5" button="hidden" tittle="Quality Control" desc="Monitor workmanship and materials to meet high standards." img={qualityAssurance}/>
        <MaterialTailwindCard imageStyle="p-5" button="hidden" tittle="Timeline Management" desc="Keep your project on schedule and avoid delays." img={timeline}/>
        <MaterialTailwindCard imageStyle="p-5" button="hidden" tittle="Problem Resolution" desc="Identify and solve issues quickly for smooth execution." img={architectSupervise}/>
      </div>
      </div>
      <Footer/>
    </div>
  )
}
